import { z } from 'zod'

export const organisationShortSchema = z.object({
  id: z.string(),
  code: z.number(),
  description: z.string(),
  fullLegalName: z.string(),
  shortLegalName: z.string(),
  isLegal: z.boolean(),
})
